window.$ = window.jQuery = require("jquery");
require("corejs-typeahead");

export function AddressAutofill() {
    var self = this;

    self.bindCity = function(selector, countryCallback, selectionCallback) {
        $(selector).typeahead(
            {
                minLength: 3,
                highlight: true
            },
            {
                source: function(query, syncResults, asyncResults) {
                    var countryID = countryCallback ? countryCallback() : 1;
                    $.ajax({
                        dataType: "json",
                        url:
                            window.jrConfig.jrApiUrl +
                            "/geonames/autocomplete?type=placename_startsWith&countryID=" +
                            countryID +
                            "&q=" +
                            query,
                        method: "GET",
                        success: function(res) {
                            asyncResults(res);
                        }
                    });
                },
                async: true,
                limit: 10,
                display: "city",
                templates: {
                    suggestion: function(obj) {
                        return "<div>" + obj.city + ", " + obj.state + " " + obj.zip + "</div>";
                    }
                }
            }
        );
        if (selectionCallback) {
            $(selector).bind("typeahead:select", selectionCallback);
        }
    };

    self.bindZip = function(selector, countryCallback, selectionCallback) {
        $(selector).typeahead(
            {
                minLength: 3,
                highlight: true
            },
            {
                source: function(query, syncResults, asyncResults) {
                    var self = this;
                    var countryID = countryCallback ? countryCallback() : 1;
                    $.ajax({
                        dataType: "json",
                        url:
                            window.jrConfig.jrApiUrl +
                            "/geonames/autocomplete?type=postalcode_startsWith&countryID=" +
                            countryID +
                            "&q=" +
                            query,
                        method: "GET",
                        success: function(res) {
                            if (res && res.length == 1) {
                                self.cancel();
                                var item = res[0];
                                if (selectionCallback) {
                                    selectionCallback({}, item);
                                }
                            } else {
                                asyncResults(res);
                            }
                        }
                    });
                },
                async: true,
                limit: 10,
                display: "zip",
                templates: {
                    suggestion: function(obj) {
                        return "<div>" + obj.city + ", " + obj.state + " " + obj.zip + "</div>";
                    }
                }
            }
        );
        $(selector)
            .on("keypress", function(e) {
                if (e.which == 13) {
                    //find the selectable item under the input, if any:
                    var selectables = $(selector)
                        .siblings(".tt-menu")
                        .find(".tt-selectable");
                    if (selectables.length > 0) {
                        $(selectables[0]).trigger("click");
                        e.preventDefault();
                    } else if (selectionCallback) {
                        selectionCallback({});
                    }
                }
            })
            .focus(function() {
                $(this).attr("autocomplete", "off");
            })
            .blur(function() {
                $(this).attr("autocomplete", "postal-code");
                if (selectionCallback) {
                    selectionCallback({});
                }
            });

        if (selectionCallback) {
            $(selector).bind("typeahead:select", selectionCallback);
        }
    };
}

export const $addressAutofill = new AddressAutofill();
